export default "https://cdn-static.gokick.com/assets/ac567471f1b9fb2f6cedfba22f3391469dbaa38e/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";